import React, { useRef } from 'react';
import JoditEditor from 'jodit-react';

const EmailComponent = ({ formData, setFormData }) => {
  const editor = useRef(null);

  const config = {
    readonly: false,
    height: 400,
    toolbarAdaptive: false,
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
    toolbarSticky: false,
    enter: 'P',
    nl2br: false,
    cleanHTML: {
      fillEmptyParagraph: false,
    },
    buttons: [
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'outdent', 'indent', '|',
      'font', 'fontsize', 'brush', 'paragraph', '|',
      'image', 'video', 'table', 'link', '|',
      'align', 'undo', 'redo', '|',
      'hr', 'copyformat', 'symbol', 'print', 'about', '|',
      'fullsize', 'source'
    ]
  };

  return (
    <div>
      <JoditEditor
        ref={editor}
        value={formData.template_content || ''}
        config={config}
        onBlur={(newContent) => setFormData({ ...formData, template_content: newContent })}
      />
    </div>
  );
};
export default EmailComponent;
